import React from "react";
import { Box, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";

const rubikfont = {
    fontFamily: "Rubik, san-serif"
};

const Layout4 = ({ data }) => {
    const products = data?.product_id || [];

    const navigate = useNavigate();

    const handleProductClick = (productId) => {
        navigate(`/product/${productId}`);
        window.scrollTo(0, 0);
    };

    return (
        <Box sx={{ bgcolor: "#000", py: 12, position: "relative", overflow: "hidden" }}>
            {/* Background Gradient */}
            <Box
                sx={{
                    position: "absolute",
                    top: "-50%",
                    right: "-10%",
                    width: "60%",
                    height: "200%",
                    background: "linear-gradient(135deg, #f5f5f5 0%, #f5f5f5 100%)",
                    transform: "rotate(-15deg)",
                    opacity: 0.08,
                }}
            />

            {/* Grid Pattern Overlay */}
            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    backgroundImage:
                        "radial-gradient(circle, rgba(255,107,53,0.1) 1px, transparent 1px)",
                    backgroundSize: "50px 50px",
                    opacity: 0.3,
                }}
            />

            <Container sx={{ position: "relative", zIndex: 1 }}>
                {/* header title */}
                <Box sx={{ mb: 8 }}>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            mb: 4,
                            flexWrap: "wrap",
                            gap: 3,
                        }}
                    >
                        <Box>
                            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
                                <Box
                                    sx={{
                                        width: "8px",
                                        height: "8px",
                                        bgcolor: "#f5f5f5",
                                        borderRadius: "50%",
                                        animation: "pulse 2s infinite",
                                    }}
                                />
                                <Typography
                                    sx={{
                                        fontSize: "13px",
                                        letterSpacing: "4px",
                                        color: "#f5f5f5",
                                        ...rubikfont,
                                        fontWeight: 600,
                                    }}
                                >
                                    LIVE NOW
                                </Typography>
                            </Box>
                            <Typography
                                sx={{
                                    fontSize: { xs: "36px", sm: "48px", md: "64px" },
                                    color: "white",
                                    ...rubikfont,
                                    fontWeight: 900,
                                    lineHeight: 0.9,
                                    mb: 2,
                                    letterSpacing: "3.5px",
                                    textAlign: { xs: "center", sm: "left" },
                                    textTransform: "uppercase"
                                }}
                            >
                                {data.title}
                            </Typography>
                        </Box>
                    </Box>
                </Box>

                {/* Product Grid */}
                <Box
                    sx={{
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "repeat(2, 1fr)", // ✅ 2 boxes per row on mobile
                            sm: "repeat(2, 1fr)",
                            md: "repeat(3, 1fr)",
                        },
                        gap: { xs: 2, sm: 3 },
                    }}
                >
                    {products.map((product, index) => (
                        <Box
                            key={product._id || index}
                            sx={{
                                position: "relative",
                                cursor: "pointer",
                                transition: "all 0.4s ease",
                                "&:hover": {
                                    transform: "translateY(-8px) scale(1.02)",
                                    "& .prod-image": { transform: "scale(1.1)" },
                                },
                            }}
                        >
                            <Box
                                sx={{
                                    position: "relative",
                                    bgcolor: "#111",
                                    border: "1px solid rgba(255,255,255,0.1)",
                                    borderRadius: "12px",
                                    overflow: "hidden",
                                    height: { xs: "100%", sm: "100%" },
                                }}
                            >
                                {/* Image */}
                                <Box
                                    sx={{
                                        height: { xs: "140px", sm: "180px", md: "220px" }, // ✅ smaller image on mobile
                                        overflow: "hidden",
                                        clipPath: "polygon(0 0, 100% 0, 100% 85%, 0 100%)",
                                    }}
                                >
                                    <img
                                        src={product.product_images?.[0] || "https://via.placeholder.com/300"}
                                        alt={product.title}
                                        className="prod-image"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            transition: "transform 0.6s ease",
                                        }}
                                    />
                                      {/* B2B Discount Badge */}
                                                                {product.b2b_discountValue && (
                                                                    <Box
                                                                        sx={{
                                                                            position: "absolute",
                                                                            top: 8,
                                                                            left: 8,
                                                                            bgcolor: "#FF6B35",
                                                                            color: "white",
                                                                            px: 1.5,
                                                                            py: 0.5,
                                                                            borderRadius: 1,
                                                                            fontSize: { xs: "11px", sm: "12px", md: "13px" },
                                                                            fontWeight: 600,
                                                                            ...rubikfont,
                                                                            zIndex: 2,
                                                                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                                                        }}
                                                                    >
                                                                        {product.b2b_discountType === "percentage" 
                                                                            ? `${product.b2b_discountValue}% OFF`
                                                                            : `₹${product.b2b_discountValue} OFF`
                                                                        }
                                                                    </Box>
                                                                )}
                                </Box>

                                {/* Content */}
                                <Box sx={{ p: { xs: 1.5, sm: 2.5 }, pt: { xs: 2, sm: 3 } }}>
                                    <Typography
                                        sx={{
                                            color: "white",
                                            fontSize: { xs: "13px", sm: "16px", md: "18px" },
                                            fontWeight: 700,
                                            mb: 0.5,
                                            textAlign: { xs: "center", sm: "left" },
                                            ...rubikfont,
                                        }}
                                    >
                                        {product.title}
                                    </Typography>

                                    {/* Price Section */}
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            flexDirection: { xs: "column", sm: "row" },
                                            gap: { xs: 0.5, sm: 0 },
                                        }}
                                    >
                                        <Box sx={{ textAlign: { xs: "center", sm: "left" } }}>
                                            {/*b2b_sellingPrice */}
                                            <Typography
                                                sx={{
                                                    color: "rgb(247, 244, 240)",
                                                    fontSize: { xs: "18px", sm: "22px", md: "24px" },
                                                    fontWeight: 900,
                                                    lineHeight: 1,
                                                    ...rubikfont,
                                                }}
                                            >
                                                ₹{product.b2b_sellingPrice}
                                            </Typography>
                                            {/*b2b_mrp */}
                                            {product.b2c_mrp && (
                                                <Typography
                                                    sx={{
                                                        color: "red",
                                                        fontSize: { xs: "10px", sm: "12px" },
                                                        textDecoration: "line-through",
                                                        mt: 0.5,
                                                    }}
                                                >
                                                    ₹{product.b2c_mrp}
                                                </Typography>
                                            )}
                                        </Box>

                                        <Box
                                            sx={{
                                                border: "1px solid white",
                                                px: { xs: 1, sm: 1.5 },
                                                py: { xs: 0.3, sm: 0.5 },
                                                borderRadius: "6px",
                                                mt: { xs: 0.5, sm: 0 },
                                            }}
                                        >
                                            <Typography
                                                sx={{
                                                    color: "#eeeae9ff",
                                                    fontSize: { xs: "9px", sm: "10px" },
                                                    fontWeight: 700,
                                                }}
                                                onClick={() => handleProductClick(product._id)}
                                            >
                                                EXPLORE →
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    ))}
                </Box>
                {/* View All Button */}
                <Box sx={{ textAlign: "center", mt: 6 }}>
                    <Box
                        onClick={() => navigate('/search', { state: { layoutId: data._id, title: data.title } })}
                        sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 2,
                            bgcolor: "black",
                            color: "white",
                            border: '1px solid ',
                            px: 5,
                            py: 2,
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            ...rubikfont,
                            fontSize: "14px",
                            fontWeight: 600,
                            letterSpacing: "2px",
                            "&:hover": {
                                color: "white",
                                bgcolor: "black",
                                transform: "translateY(-2px)",
                            },
                        }}
                    >
                        VIEW ALL
                        <Box component="span" sx={{ fontSize: "18px" }}>→</Box>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Layout4;
